import React from 'react';
import { JOURNEY_VIEWS } from '../utils/journeyView';
import './JourneyTabs.css';

function niceDate(iso) {
  const d = new Date(`${iso}T12:00:00`);
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

/**
 * Live / Backtested / Full Journey for a strategy with a "live since" date.
 * Renders nothing without one, so strategies that never set it look as before.
 */
export default function JourneyTabs({ liveSince, view, onChange, className = '' }) {
  if (!liveSince) return null;
  const note = view === 'live'
    ? `Live trading since ${niceDate(liveSince)}`
    : view === 'backtested'
      ? `Backtested results before ${niceDate(liveSince)}`
      : `Backtested before ${niceDate(liveSince)} · live from ${niceDate(liveSince)}`;
  return (
    <div className={`journey-tabs ${className}`.trim()}>
      <div className="journey-tabs-bar" role="tablist" aria-label="Live or backtested results">
        {JOURNEY_VIEWS.map((v) => (
          <button
            key={v.id}
            type="button"
            role="tab"
            aria-selected={view === v.id}
            className={`journey-tab is-${v.id}${view === v.id ? ' is-active' : ''}`}
            onClick={() => onChange(v.id)}
          >
            {v.id !== 'full' ? <span className="journey-tab-dot" aria-hidden="true" /> : null}
            {v.label}
          </button>
        ))}
      </div>
      <span className="journey-tabs-note">{note}</span>
    </div>
  );
}
